"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
var a = {
	16: {
		Artwork: (e) => {
			let a = i();
			return /* @__PURE__ */ r(t, {
				viewBox: "0 0 16 16",
				fill: "none",
				...e,
				children: [
					/* @__PURE__ */ n("path", {
						d: "M4.7627 1C6.19734 1 7.55527 2.33301 8.98992 2.33301H10.667C12.5333 2.33301 13.4667 2.33319 14.1797 2.69629C14.8069 3.01586 15.3171 3.52612 15.6367 4.15332C16 4.86636 16 5.80015 16 7.66699V9.66699C16 11.5334 15.9999 12.4667 15.6367 13.1797C15.3171 13.8069 14.8069 14.3171 14.1797 14.6367C13.4667 14.9999 12.5334 15 10.667 15H5.33301C3.46659 15 2.53328 14.9999 1.82031 14.6367C1.19311 14.3171 0.682859 13.8069 0.363281 13.1797C0.000110418 12.4667 1.23378e-09 11.5334 0 9.66699V7.66699C0 7.23083 0.000249491 6.8453 0.00488281 6.50195C0.00207341 6.46749 0 6.43265 0 6.39746V4.33301C0.000175038 2.49232 1.49232 1.00018 3.33301 1H4.7627Z",
						fill: "#027ED4"
					}),
					/* @__PURE__ */ n("mask", {
						id: `${a}-mask0_218_49`,
						style: { maskType: "luminance" },
						maskUnits: "userSpaceOnUse",
						x: 0,
						y: 1,
						width: 16,
						height: 14,
						children: /* @__PURE__ */ n("path", {
							d: "M4.7627 1C6.19734 1 7.55527 2.33301 8.98992 2.33301H10.667C12.5333 2.33301 13.4667 2.33319 14.1797 2.69629C14.8069 3.01586 15.3171 3.52612 15.6367 4.15332C16 4.86636 16 5.80015 16 7.66699V9.66699C16 11.5334 15.9999 12.4667 15.6367 13.1797C15.3171 13.8069 14.8069 14.3171 14.1797 14.6367C13.4667 14.9999 12.5334 15 10.667 15H5.33301C3.46659 15 2.53328 14.9999 1.82031 14.6367C1.19311 14.3171 0.682859 13.8069 0.363281 13.1797C0.000110418 12.4667 1.23378e-09 11.5334 0 9.66699V7.66699C0 7.23083 0.000249491 6.8453 0.00488281 6.50195C0.00207341 6.46749 0 6.43265 0 6.39746V4.33301C0.000175038 2.49232 1.49232 1.00018 3.33301 1H4.7627Z",
							fill: "white"
						})
					}),
					/* @__PURE__ */ n("g", {
						mask: `url(#${a}-mask0_218_49)`,
						children: /* @__PURE__ */ n("path", {
							d: "M0.00488192 6.50193L0.421511 6.50756L0.421777 6.48779L0.420171 6.46808L0.00488192 6.50193ZM8.98992 2.33299V2.74965H10.667V2.33299V1.91632H8.98992V2.33299ZM10.667 2.33299V2.74965C11.607 2.74965 12.287 2.75002 12.8219 2.79375C13.3519 2.83707 13.7026 2.92089 13.9906 3.06756L14.1797 2.69627L14.3688 2.32502C13.9438 2.10859 13.4713 2.01072 12.8898 1.96318C12.3131 1.91604 11.5933 1.91632 10.667 1.91632V2.33299ZM14.1797 2.69627L13.9906 3.06756C14.5394 3.34719 14.9858 3.79367 15.2655 4.34247L15.6367 4.1533L16.008 3.96414C15.6484 3.25855 15.0745 2.68454 14.3688 2.32502L14.1797 2.69627ZM15.6367 4.1533L15.2655 4.34247C15.4122 4.63045 15.496 4.98119 15.5393 5.51138C15.583 6.04641 15.5833 6.72667 15.5833 7.66697H16H16.4167C16.4167 6.74043 16.417 6.02037 16.3699 5.44354C16.3224 4.86186 16.2246 4.3892 16.008 3.96414L15.6367 4.1533ZM16 7.66697H15.5833V9.66697H16H16.4167V7.66697H16ZM16 9.66697H15.5833C15.5833 10.6071 15.583 11.2871 15.5393 11.8219C15.4959 12.3519 15.4121 12.7026 15.2654 12.9906L15.6367 13.1797L16.008 13.3688C16.2245 12.9438 16.3223 12.4713 16.3698 11.8898C16.417 11.3132 16.4167 10.5933 16.4167 9.66697H16ZM15.6367 13.1797L15.2654 12.9906C14.9857 13.5394 14.5393 13.9858 13.9905 14.2655L14.1797 14.6367L14.3688 15.008C15.0745 14.6484 15.6484 14.0745 16.008 13.3688L15.6367 13.1797ZM14.1797 14.6367L13.9905 14.2655C13.7025 14.4122 13.3519 14.4959 12.8219 14.5393C12.2871 14.583 11.6071 14.5833 10.667 14.5833V15V15.4167C11.5933 15.4167 12.3132 15.417 12.8898 15.3698C13.4713 15.3223 13.9438 15.2245 14.3688 15.008L14.1797 14.6367ZM10.667 15V14.5833H5.33301V15V15.4167H10.667V15ZM5.33301 15V14.5833C4.39294 14.5833 3.7129 14.583 3.17806 14.5393C2.64807 14.4959 2.29741 14.4121 2.00943 14.2654L1.82031 14.6367L1.63115 15.008C2.05614 15.2245 2.52866 15.3223 3.11017 15.3698C3.68683 15.417 4.40666 15.4167 5.33301 15.4167V15ZM1.82031 14.6367L2.00943 14.2654C1.46062 13.9857 1.01416 13.5393 0.734533 12.9905L0.36328 13.1797L-0.00799432 13.3688C0.351531 14.0745 0.925541 14.6484 1.63115 15.008L1.82031 14.6367ZM0.36328 13.1797L0.734533 12.9905C0.587841 12.7025 0.50405 12.3519 0.460732 11.8219C0.417017 11.2871 0.416666 10.6071 0.416666 9.66697H-8.64267e-07H-0.416668C-0.416668 10.5933 -0.416964 11.3132 -0.369831 11.8898C-0.322301 12.4713 -0.224473 12.9438 -0.00799432 13.3688L0.36328 13.1797ZM-8.64267e-07 9.66697H0.416666V7.66697H-8.64267e-07H-0.416668V9.66697H-8.64267e-07ZM-8.64267e-07 7.66697H0.416666C0.416666 7.23029 0.416922 6.84761 0.421511 6.50756L0.00488192 6.50193L-0.411747 6.49631C-0.416425 6.84296 -0.416668 7.23133 -0.416668 7.66697H-8.64267e-07ZM0.00488192 6.50193L0.420171 6.46808C0.417816 6.43919 0.416666 6.41679 0.416666 6.39744H-8.64267e-07H-0.416668C-0.416668 6.44848 -0.413671 6.49575 -0.410408 6.53578L0.00488192 6.50193ZM-8.64267e-07 6.39744H0.416666V4.33299H-8.64267e-07L-0.416668 4.33295V6.39744H-8.64267e-07ZM-8.64267e-07 4.33299H0.416666C0.416819 2.72238 1.72244 1.4168 3.33305 1.41665L3.33301 0.99998V0.583313C1.26223 0.583511 -0.416471 2.26217 -0.416668 4.33295L-8.64267e-07 4.33299ZM3.33301 0.99998L3.33305 1.41665H4.7627V0.99998V0.583313H3.33301V0.99998ZM4.7627 0.99998V1.41665C5.36809 1.41665 5.97768 1.69924 6.69681 2.04251C7.37397 2.36574 8.16066 2.74965 8.98992 2.74965V2.33299V1.91632C8.38453 1.91632 7.77493 1.63373 7.0558 1.29046C6.37864 0.967226 5.59195 0.583313 4.7627 0.583313V0.99998Z",
							fill: `url(#${a}-paint0_linear_218_49)`
						})
					}),
					/* @__PURE__ */ n("path", {
						d: "M12.6666 4.54163H3.33333C1.60744 4.54163 0.208332 5.94074 0.208332 7.66663V11.6666C0.208332 13.3925 1.60744 14.7916 3.33333 14.7916H12.6666C14.3925 14.7916 15.7916 13.3925 15.7916 11.6666V7.66663C15.7916 5.94074 14.3925 4.54163 12.6666 4.54163Z",
						fill: "#027ED4",
						stroke: `url(#${a}-paint1_linear_218_49)`,
						strokeWidth: .416667
					}),
					/* @__PURE__ */ n("path", {
						opacity: .2,
						d: "M12.6667 4.33331H3.33333C1.49238 4.33331 0 5.8257 0 7.66664V11.6667C0 13.5076 1.49238 15 3.33333 15H12.6667C14.5076 15 16 13.5076 16 11.6667V7.66664C16 5.8257 14.5076 4.33331 12.6667 4.33331Z",
						fill: `url(#${a}-paint2_linear_218_49)`
					}),
					/* @__PURE__ */ r("defs", { children: [
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint0_linear_218_49`,
							x1: 8,
							y1: .99998,
							x2: 8,
							y2: 15,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", {
								stopColor: "white",
								stopOpacity: .12
							}), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						}),
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint1_linear_218_49`,
							x1: 8,
							y1: 4.33329,
							x2: 8,
							y2: 15,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", {
								stopColor: "white",
								stopOpacity: .12
							}), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						}),
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint2_linear_218_49`,
							x1: 0,
							y1: 4.33331,
							x2: 11.0031,
							y2: 14.6408,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", { stopColor: "white" }), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						})
					] })
				]
			});
		},
		width: 16,
		height: 16
	},
	24: {
		Artwork: (e) => {
			let a = i();
			return /* @__PURE__ */ r(t, {
				viewBox: "0 0 24 24",
				fill: "none",
				...e,
				children: [
					/* @__PURE__ */ n("path", {
						d: "M7.14405 1.5C9.29601 1.5 11.3329 3.49951 13.4849 3.49951H16.0005C18.7999 3.49951 20.2001 3.49979 21.2696 4.04444C22.2104 4.52379 22.9756 5.28918 23.455 6.22998C24 7.29954 24 8.70022 24 11.5005V14.5005C24 17.3001 23.9998 18.7001 23.455 19.7696C22.9756 20.7104 22.2104 21.4756 21.2696 21.955C20.2001 22.4998 18.8001 22.5 16.0005 22.5H7.99952C5.19989 22.5 3.79992 22.4998 2.73046 21.955C1.78966 21.4756 1.02429 20.7104 0.544922 19.7696C0.000165626 18.7001 1.85067e-09 17.3001 0 14.5005V11.5005C0 10.8462 0.000374237 10.268 0.00732422 9.75292C0.00311012 9.70123 0 9.64898 0 9.59619V6.49952C0.000262557 3.73848 2.23848 1.50027 4.99952 1.5H7.14405Z",
						fill: "#027ED4"
					}),
					/* @__PURE__ */ n("mask", {
						id: `${a}-mask0_218_54`,
						style: { maskType: "luminance" },
						maskUnits: "userSpaceOnUse",
						x: 0,
						y: 1,
						width: 24,
						height: 22,
						children: /* @__PURE__ */ n("path", {
							d: "M7.14405 1.5C9.29601 1.5 11.3329 3.49951 13.4849 3.49951H16.0005C18.7999 3.49951 20.2001 3.49979 21.2696 4.04444C22.2104 4.52379 22.9756 5.28918 23.455 6.22998C24 7.29954 24 8.70022 24 11.5005V14.5005C24 17.3001 23.9998 18.7001 23.455 19.7696C22.9756 20.7104 22.2104 21.4756 21.2696 21.955C20.2001 22.4998 18.8001 22.5 16.0005 22.5H7.99952C5.19989 22.5 3.79992 22.4998 2.73046 21.955C1.78966 21.4756 1.02429 20.7104 0.544922 19.7696C0.000165626 18.7001 1.85067e-09 17.3001 0 14.5005V11.5005C0 10.8462 0.000374237 10.268 0.00732422 9.75292C0.00311012 9.70123 0 9.64898 0 9.59619V6.49952C0.000262557 3.73848 2.23848 1.50027 4.99952 1.5H7.14405Z",
							fill: "white"
						})
					}),
					/* @__PURE__ */ n("g", {
						mask: `url(#${a}-mask0_218_54)`,
						children: /* @__PURE__ */ n("path", {
							d: "M0.00738585 9.75292L0.63233 9.76137L0.632729 9.73172L0.63032 9.70215L0.00738585 9.75292ZM13.4849 3.49952V4.12451H16.0006V3.49952V2.87451H13.4849V3.49952ZM16.0006 3.49952V4.12451C17.4106 4.12451 18.4306 4.12506 19.2329 4.19066C20.0279 4.25564 20.554 4.38137 20.986 4.60137L21.2696 4.04444L21.5533 3.48756C20.9158 3.16292 20.207 3.01611 19.3348 2.9448C18.4697 2.87409 17.39 2.87451 16.0006 2.87451V3.49952ZM21.2696 4.04444L20.986 4.60137C21.8092 5.02082 22.4788 5.69054 22.8983 6.51374L23.4551 6.22998L24.0121 5.94624C23.4727 4.88786 22.6118 4.02684 21.5533 3.48756L21.2696 4.04444ZM23.4551 6.22998L22.8983 6.51374C23.1184 6.94571 23.2441 7.47182 23.309 8.2671C23.3746 9.06965 23.375 10.09 23.375 11.5005H24.0001H24.6251C24.6251 10.1107 24.6256 9.03059 24.5549 8.16534C24.4837 7.29282 24.337 6.58383 24.0121 5.94624L23.4551 6.22998ZM24.0001 11.5005H23.375V14.5005H24.0001H24.6251V11.5005H24.0001ZM24.0001 14.5005H23.375C23.375 15.9107 23.3746 16.9307 23.309 17.7329C23.2439 18.5279 23.1182 19.0539 22.8982 19.4859L23.4551 19.7696L24.0121 20.0532C24.3368 19.4157 24.4835 18.707 24.5548 17.8347C24.6256 16.9698 24.6251 15.89 24.6251 14.5005H24.0001ZM23.4551 19.7696L22.8982 19.4859C22.4786 20.3091 21.809 20.9787 20.9858 21.3983L21.2696 21.955L21.5533 22.512C22.6118 21.9726 23.4727 21.1118 24.0121 20.0532L23.4551 19.7696ZM21.2696 21.955L20.9858 21.3983C20.5538 21.6183 20.0279 21.7439 19.2329 21.809C18.4307 21.8745 17.4107 21.875 16.0006 21.875V22.5V23.1251C17.39 23.1251 18.4699 23.1255 19.3348 23.0547C20.207 22.9834 20.9158 22.8368 21.5533 22.512L21.2696 21.955ZM16.0006 22.5V21.875H7.99958V22.5V23.1251H16.0006V22.5ZM7.99958 22.5V21.875C6.58947 21.875 5.56941 21.8745 4.76715 21.809C3.97217 21.7439 3.44618 21.6182 3.01421 21.3981L2.73053 21.955L2.44679 22.512C3.08427 22.8368 3.79305 22.9834 4.66532 23.0547C5.53031 23.1255 6.61005 23.1251 7.99958 23.1251V22.5ZM2.73053 21.955L3.01421 21.3981C2.19099 20.9785 1.5213 20.309 1.10186 19.4858L0.544983 19.7696L-0.0119286 20.0532C0.52736 21.1118 1.38837 21.9726 2.44679 22.512L2.73053 21.955ZM0.544983 19.7696L1.10186 19.4858C0.881825 19.0538 0.756138 18.5279 0.691161 17.7329C0.625589 16.9307 0.625062 15.9107 0.625062 14.5005H6.16312e-05H-0.624939C-0.624939 15.89 -0.625383 16.9698 -0.554683 17.8347C-0.483388 18.707 -0.336646 19.4157 -0.0119286 20.0532L0.544983 19.7696ZM6.16312e-05 14.5005H0.625062V11.5005H6.16312e-05H-0.624939V14.5005H6.16312e-05ZM6.16312e-05 11.5005H0.625062C0.625062 10.8455 0.625446 10.2714 0.63233 9.76137L0.00738585 9.75292L-0.617557 9.7445C-0.624574 10.2645 -0.624939 10.847 -0.624939 11.5005H6.16312e-05ZM0.00738585 9.75292L0.63032 9.70215C0.626787 9.65882 0.625062 9.62522 0.625062 9.59619H6.16312e-05H-0.624939C-0.624939 9.67275 -0.620443 9.74366 -0.615549 9.8037L0.00738585 9.75292ZM6.16312e-05 9.59619H0.625062V6.49952H6.16312e-05L-0.624939 6.49946V9.59619H6.16312e-05ZM6.16312e-05 6.49952H0.625062C0.625292 4.0836 2.58372 2.12523 4.99964 2.12501L4.99958 1.5V0.875C1.89341 0.875297 -0.624643 3.39329 -0.624939 6.49946L6.16312e-05 6.49952ZM4.99958 1.5L4.99964 2.12501H7.14411V1.5V0.875H4.99958V1.5ZM7.14411 1.5V2.12501C8.0522 2.12501 8.96658 2.54889 10.0453 3.0638C11.061 3.54864 12.2411 4.12451 13.4849 4.12451V3.49952V2.87451C12.5769 2.87451 11.6625 2.45063 10.5838 1.93572C9.56802 1.45087 8.38799 0.875 7.14411 0.875V1.5Z",
							fill: `url(#${a}-paint0_linear_218_54)`
						})
					}),
					/* @__PURE__ */ n("path", {
						d: "M19 6.8125H5.00006C2.41123 6.8125 0.312561 8.91117 0.312561 11.5V17.5C0.312561 20.0888 2.41123 22.1875 5.00006 22.1875H19C21.5888 22.1875 23.6875 20.0888 23.6875 17.5V11.5C23.6875 8.91117 21.5888 6.8125 19 6.8125Z",
						fill: "#027ED4",
						stroke: `url(#${a}-paint1_linear_218_54)`,
						strokeWidth: .625001
					}),
					/* @__PURE__ */ n("path", {
						opacity: .2,
						d: "M19 6.5H4.99999C2.23857 6.5 0 8.73857 0 11.5V17.5001C0 20.2615 2.23857 22.5 4.99999 22.5H19C21.7614 22.5 24 20.2615 24 17.5001V11.5C24 8.73857 21.7614 6.5 19 6.5Z",
						fill: `url(#${a}-paint2_linear_218_54)`
					}),
					/* @__PURE__ */ r("defs", { children: [
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint0_linear_218_54`,
							x1: 12.0001,
							y1: 1.5,
							x2: 12.0001,
							y2: 22.5,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", {
								stopColor: "white",
								stopOpacity: .12
							}), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						}),
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint1_linear_218_54`,
							x1: 12.0001,
							y1: 6.49999,
							x2: 12.0001,
							y2: 22.5,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", {
								stopColor: "white",
								stopOpacity: .12
							}), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						}),
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint2_linear_218_54`,
							x1: 0,
							y1: 6.5,
							x2: 16.5046,
							y2: 21.9612,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", { stopColor: "white" }), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						})
					] })
				]
			});
		},
		width: 24,
		height: 24
	},
	40: {
		Artwork: (e) => {
			let a = i();
			return /* @__PURE__ */ r(t, {
				viewBox: "0 0 40 40",
				fill: "none",
				...e,
				children: [
					/* @__PURE__ */ n("path", {
						d: "M11.9067 2.5C15.4934 2.5 18.8882 5.83252 22.4748 5.83252H26.6675C31.3333 5.83252 33.6667 5.83298 35.4492 6.74073C37.0173 7.53965 38.2927 8.8153 39.0918 10.3833C40 12.1659 40 14.5004 40 19.1675V24.1675C40 28.8335 39.9997 31.1667 39.0918 32.9492C38.2927 34.5173 37.0173 35.7927 35.4492 36.5918C33.6667 37.4997 31.3335 37.5 26.6675 37.5H13.3325C8.66648 37.5 6.3332 37.4997 4.55078 36.5918C2.98277 35.7927 1.70715 34.5173 0.908203 32.9492C0.000276044 31.1667 3.08445e-09 28.8335 0 24.1675V19.1675C0 18.0771 0.000623728 17.1132 0.012207 16.2549C0.00518353 16.1687 0 16.0816 0 15.9937V10.8325C0.000437595 6.2308 3.7308 2.50045 8.33253 2.5H11.9067Z",
						fill: "#027ED4"
					}),
					/* @__PURE__ */ n("mask", {
						id: `${a}-mask0_218_59`,
						style: { maskType: "luminance" },
						maskUnits: "userSpaceOnUse",
						x: 0,
						y: 2,
						width: 40,
						height: 36,
						children: /* @__PURE__ */ n("path", {
							d: "M11.9067 2.5C15.4934 2.5 18.8882 5.83252 22.4748 5.83252H26.6675C31.3333 5.83252 33.6667 5.83298 35.4492 6.74073C37.0173 7.53965 38.2927 8.8153 39.0918 10.3833C40 12.1659 40 14.5004 40 19.1675V24.1675C40 28.8335 39.9997 31.1667 39.0918 32.9492C38.2927 34.5173 37.0173 35.7927 35.4492 36.5918C33.6667 37.4997 31.3335 37.5 26.6675 37.5H13.3325C8.66648 37.5 6.3332 37.4997 4.55078 36.5918C2.98277 35.7927 1.70715 34.5173 0.908203 32.9492C0.000276044 31.1667 3.08445e-09 28.8335 0 24.1675V19.1675C0 18.0771 0.000623728 17.1132 0.012207 16.2549C0.00518353 16.1687 0 16.0816 0 15.9937V10.8325C0.000437595 6.2308 3.7308 2.50045 8.33253 2.5H11.9067Z",
							fill: "white"
						})
					}),
					/* @__PURE__ */ n("g", {
						mask: `url(#${a}-mask0_218_59)`,
						children: /* @__PURE__ */ n("path", {
							d: "M0.0123097 16.2549L1.05388 16.269L1.05455 16.2196L1.05053 16.1703L0.0123097 16.2549ZM22.4749 5.83257V6.87422H26.6676V5.83257V4.79089H22.4749V5.83257ZM26.6676 5.83257V6.87422C29.0176 6.87422 30.7176 6.87514 32.0549 6.98447C33.3799 7.09277 34.2566 7.30232 34.9766 7.66899L35.4494 6.74077L35.9221 5.81264C34.8596 5.27157 33.6784 5.02689 32.2246 4.90804C30.7829 4.79019 28.9834 4.79089 26.6676 4.79089V5.83257ZM35.4494 6.74077L34.9766 7.66899C36.3486 8.36807 37.4646 9.48427 38.1639 10.8563L39.0919 10.3833L40.0201 9.91044C39.1211 8.14647 37.6864 6.71144 35.9221 5.81264L35.4494 6.74077ZM39.0919 10.3833L38.1639 10.8563C38.5306 11.5762 38.7401 12.4531 38.8484 13.7785C38.9576 15.1161 38.9584 16.8168 38.9584 19.1675H40.0001H41.0419C41.0419 16.8512 41.0426 15.051 40.9249 13.6089C40.8061 12.1547 40.5616 10.9731 40.0201 9.91044L39.0919 10.3833ZM40.0001 19.1675H38.9584V24.1675H40.0001H41.0419V19.1675H40.0001ZM40.0001 24.1675H38.9584C38.9584 26.5178 38.9576 28.2178 38.8484 29.5548C38.7399 30.8798 38.5304 31.7565 38.1636 32.4765L39.0919 32.9493L40.0201 33.422C40.5614 32.3595 40.8059 31.1783 40.9246 29.7245C41.0426 28.283 41.0419 26.4833 41.0419 24.1675H40.0001ZM39.0919 32.9493L38.1636 32.4765C37.4644 33.8485 36.3484 34.9645 34.9764 35.6638L35.4494 36.5918L35.9221 37.52C37.6864 36.621 39.1211 35.1863 40.0201 33.422L39.0919 32.9493ZM35.4494 36.5918L34.9764 35.6638C34.2564 36.0305 33.3799 36.2398 32.0549 36.3483C30.7179 36.4575 29.0179 36.4583 26.6676 36.4583V37.5V38.5418C28.9834 38.5418 30.7831 38.5425 32.2246 38.4245C33.6784 38.3058 34.8596 38.0613 35.9221 37.52L35.4494 36.5918ZM26.6676 37.5V36.4583H13.3326V37.5V38.5418H26.6676V37.5ZM13.3326 37.5V36.4583C10.9825 36.4583 9.28235 36.4575 7.94525 36.3483C6.62028 36.2398 5.74363 36.0303 5.02368 35.6635L4.55088 36.5918L4.07798 37.52C5.14045 38.0613 6.32175 38.3058 7.77553 38.4245C9.21718 38.5425 11.0168 38.5418 13.3326 38.5418V37.5ZM4.55088 36.5918L5.02368 35.6635C3.65165 34.9643 2.5355 33.8483 1.83644 32.4763L0.908305 32.9493L-0.0198809 33.422C0.878933 35.1863 2.31396 36.621 4.07798 37.52L4.55088 36.5918ZM0.908305 32.9493L1.83644 32.4763C1.46971 31.7563 1.26023 30.8798 1.15194 29.5548C1.04265 28.2178 1.04177 26.5178 1.04177 24.1675H0.000102758H-1.04156C-1.04156 26.4833 -1.0423 28.283 -0.924472 29.7245C-0.805647 31.1783 -0.561077 32.3595 -0.0198809 33.422L0.908305 32.9493ZM0.000102758 24.1675H1.04177V19.1675H0.000102758H-1.04156V24.1675H0.000102758ZM0.000102758 19.1675H1.04177C1.04177 18.0758 1.04241 17.1191 1.05388 16.269L0.0123097 16.2549L-1.02926 16.2409C-1.04096 17.1075 -1.04156 18.0784 -1.04156 19.1675H0.000102758ZM0.0123097 16.2549L1.05053 16.1703C1.04465 16.0981 1.04177 16.0421 1.04177 15.9937H0.000102758H-1.04156C-1.04156 16.1213 -1.03407 16.2395 -1.02591 16.3395L0.0123097 16.2549ZM0.000102758 15.9937H1.04177V10.8326H0.000102758L-1.04156 10.8325V15.9937H0.000102758ZM0.000102758 10.8326H1.04177C1.04215 6.80604 4.3062 3.54209 8.33273 3.54172L8.33263 2.50004V1.45837C3.15568 1.45887 -1.04107 5.65552 -1.04156 10.8325L0.000102758 10.8326ZM8.33263 2.50004L8.33273 3.54172H11.9069V2.50004V1.45837H8.33263V2.50004ZM11.9069 2.50004V3.54172C13.4203 3.54172 14.9443 4.24819 16.7421 5.10637C18.435 5.91444 20.4018 6.87422 22.4749 6.87422V5.83257V4.79089C20.9614 4.79089 19.4374 4.08442 17.6396 3.22624C15.9467 2.41816 13.98 1.45837 11.9069 1.45837V2.50004Z",
							fill: `url(#${a}-paint0_linear_218_59)`
						})
					}),
					/* @__PURE__ */ n("path", {
						d: "M31.6667 11.3541H8.33344C4.01871 11.3541 0.520935 14.8519 0.520935 19.1666V29.1666C0.520935 33.4813 4.01871 36.9791 8.33344 36.9791H31.6667C35.9814 36.9791 39.4792 33.4813 39.4792 29.1666V19.1666C39.4792 14.8519 35.9814 11.3541 31.6667 11.3541Z",
						fill: "#027ED4",
						stroke: `url(#${a}-paint1_linear_218_59)`,
						strokeWidth: 1.04167
					}),
					/* @__PURE__ */ n("path", {
						opacity: .2,
						d: "M31.6667 10.8333H8.33332C3.73096 10.8333 0 14.5642 0 19.1666V29.1667C0 33.769 3.73096 37.5 8.33332 37.5H31.6667C36.269 37.5 40 33.769 40 29.1667V19.1666C40 14.5642 36.269 10.8333 31.6667 10.8333Z",
						fill: `url(#${a}-paint2_linear_218_59)`
					}),
					/* @__PURE__ */ r("defs", { children: [
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint0_linear_218_59`,
							x1: 20.0001,
							y1: 2.50004,
							x2: 20.0001,
							y2: 37.5,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", {
								stopColor: "white",
								stopOpacity: .12
							}), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						}),
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint1_linear_218_59`,
							x1: 20.0001,
							y1: 10.8333,
							x2: 20.0001,
							y2: 37.5,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", {
								stopColor: "white",
								stopOpacity: .12
							}), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						}),
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint2_linear_218_59`,
							x1: 0,
							y1: 10.8333,
							x2: 27.5077,
							y2: 36.602,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", { stopColor: "white" }), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						})
					] })
				]
			});
		},
		width: 40,
		height: 40
	}
}, o = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: a[t],
	...r
});
//#endregion
export { o as FolderIcon };
